var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-contain"},[_c('video',{attrs:{"src":_vm.videourl,"poster":_vm.posterimg,"controls":"","controlslist":"nodownload","width":"300","height":"200"},on:{"contextmenu":function($event){$event.preventDefault();return _vm.handleRMouse.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }